import React from "react";
import { Flex, Box, Image } from "rebass";
import { theme } from "../utils/theme";
import facebookLogo from "../static/images/facebook.svg";
import twitterLogo from "../static/images/twitter-logo-white.png";
import pinterestLogo from "../static/images/pinterest.svg";
import instagramLogo from "../static/images/instagram.svg";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <Flex
      flexGrow={1}
      height={[100, null, null, 50]}
      maxHeight={[100, null, null, 50]}
      bg={theme.background}
      alignItems="center"
      mt={10}
      pt={10}
      pl={[0, null, 150]}
      pr={[0, null, 150]}
      pb={10}
      fontSize={"0.6em"}
      justifyContent="center"
      color="white"
      flexDirection={["column", null, "row"]}
    >
      <Flex
        width={[1, null, 1 / 4]}
        alignItems="center"
        justifyContent="center"
      >
        <Box mr={3}>
          <Link
            style={{ textDecoration: "none", cursor: "pointer" }}
            color="white"
            p={2}
            to="/privacy"
          >
            PRIVACY
          </Link>
        </Box>
        <Box>
          <Link
            style={{ textDecoration: "none", cursor: "pointer" }}
            color="white"
            p={2}
            to="/cookie"
          >
            COOKIE
          </Link>
        </Box>
      </Flex>
      <Flex
        width={[1, null, 2 / 4]}
        alignItems="center"
        justifyContent="center"
        p={2}
      >
        COPYRIGHT &copy; HERNO S.P.A {new Date().getFullYear()} - ALL RIGHTS
        RESERVED
      </Flex>
      <Flex
        width={[1, null, 1 / 4]}
        alignItems="center"
        justifyContent="center"
      >
        <a
          style={{ textDecoration: "none" }}
          href="https://www.facebook.com/HernoSpa/"
          target="_blank"
        >
          <Image src={facebookLogo} m={2} height={21}></Image>
        </a>

        <a
          style={{ textDecoration: "none" }}
          href="https://twitter.com/Herno_official"
          target="_blank"
        >
          <Image src={twitterLogo} m={2} height={21}></Image>
        </a>

        <a
          style={{ textDecoration: "none" }}
          href="https://www.instagram.com/herno_official/"
          target="_blank"
        >
          <Image src={instagramLogo} m={2} height={21}></Image>
        </a>

        <a
          style={{ textDecoration: "none" }}
          href="https://www.pinterest.it/hernospa/"
          target="_blank"
        >
          <Image src={pinterestLogo} m={2} height={21}></Image>
        </a>
      </Flex>
    </Flex>
  );
};

export { Footer };
